const lang = {
    months : "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
    monthsShort : "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
    weekdays : "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort : "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin : "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
    longDateFormat : {
        LT : "HH:mm",
        L : "DD/MM/YYYY",
        LL : "D MMMM YYYY",
        LLL : "D MMMM YYYY LT",
        LLLL : "dddd D MMMM YYYY LT"
    },
    calendar : {
        sameDay: "[Aujourd'hui à] LT",
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    },
    relativeTime : {
        fullFormat : {
            future: "%s restant",
            past: "il y a %s",
            s: "< 1 min",
            m: "1 min",
            mm: "%d min",
            h: "1 heure",
            hm: "%d heure, %d min",
            hmm: "%d heure, %d min",
            hh: "%d heures",
            hhm: "%d heures, %d min",
            hhmm: "%d heures, %d min",
            d: "%d jour",
            dh: "%d jour, %d heure",
            dhh: "%d jour, %d heures",
            dd: "%d jours",
            ddh: "%d jours, $d heure",
            ddhh: "%d jours, %d heures",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yM: "%d an, %d mois",
            yMM: "%d an, %d mois",
            yy: "%d années",
            yyM: "%d années, %d mois",
            yyMM: "%d années, %d mois"
        },
        shortFormat : {
            future: "%s restant",
            past: "Il y a %s",
            s: "< 1m",
            m: "1m",
            mm: "%dm",
            h: "1h",
            hm: "%dh, %dm",
            hmm: "%dh, %dm",
            hh: "%dh",
            hhm: "%dh, %dm",
            hhmm: "%dh, %dm",
            d: "%dj",
            dh: "%dj, %dh",
            dhh: "%dj, %dh",
            dd: "%dj",
            ddh: "%dj, $dh",
            ddhh: "%dj, %dh",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yM: "%d an, %d mois",
            yMM: "%d an, %d mois",
            yy: "%d années",
            yyM: "%d années, %d mois",
            yyMM: "%d années, %d mois"
        }
    },
    ordinal : function (number) {
        return number === 1 ? 'er' : 'ème';
    }
};

export default lang;



// WEBPACK FOOTER //
// ./src/web/js/app/lib/moment/lang/fr.js